import React from "react";
import { Link } from "react-router-dom";
import {
  RecommendationsGradingButton,
  RecommendationsGradingPopoverButton,
} from "./_styled";
import { Popover, Type } from "@ebscois/react-component-library";
import {
  affordances,
  linkTypes,
  logTopicContentLinkClicked,
} from "../../../util/analytics";

const extractTextFromElement = (element) => {
  if (typeof element === "string") return element;
  if (Array.isArray(element))
    return element.map(extractTextFromElement).join("");
  if (React.isValidElement(element))
    return extractTextFromElement(element.props.children);
  return "";
};

const handleOpen = ({ affordance, type, telemetryData }) => {
  logTopicContentLinkClicked({ affordance, type, ...telemetryData });
};

const buildPopover = ({
  children,
  handleRecommendationsGradingDialogOpen,
  popoverContent,
  popoverLink,
  affordance,
  linkType,
  telemetryData,
}) => {
  const label = extractTextFromElement(children) ?? "";

  return (
    <Popover
      trigger={
        <RecommendationsGradingPopoverButton kind="anchor" linkComponent={Link}>
          [{label}]
        </RecommendationsGradingPopoverButton>
      }
      toggle="hover"
      popperComponentProps={{
        variant: "primary",
        width: "medium",
      }}
      onOpen={() => {
        handleOpen({ affordance, type: linkType, telemetryData });
      }}
    >
      <Type fontSize="xs">
        <span dangerouslySetInnerHTML={{ __html: popoverContent }} />
      </Type>
      <RecommendationsGradingButton
        kind="anchor"
        size="xs"
        marginTop="xs"
        onClick={() =>
          handleRecommendationsGradingDialogOpen({ affordance, telemetryData })
        }
      >
        <span dangerouslySetInnerHTML={{ __html: popoverLink }} />
      </RecommendationsGradingButton>
    </Popover>
  );
};

export default function recommendationGradingProcessor({
  handleRecommendationsGradingDialogOpen,
  content,
  telemetryData,
}) {
  const processRecommendation = ({ node, children, processDefault }) => {
    const dataType = node.attribs?.["data-type"];
    const popover = content?.popover?.[dataType];
    let affordance;
    let linkType;
    switch (dataType) {
      case "strong":
        affordance = affordances.STRONG_RECOMMENDATION_POPOVER;
        linkType = linkTypes.STRONG_RECOMMENDATION;
        break;
      case "conditional":
        affordance = affordances.CONDITIONAL_RECOMMENDATION_POPOVER;
        linkType = linkTypes.CONDITIONAL_RECOMMENDATION;
        break;
      default:
        break;
    }

    if (popover) {
      return buildPopover({
        children,
        handleRecommendationsGradingDialogOpen,
        popoverContent: popover.content,
        popoverLink: content.popover.link,
        affordance,
        linkType,
        telemetryData,
      });
    }

    return processDefault(node, children);
  };

  return { processRecommendation };
}
